import { Link } from 'react-router-dom'
import { UserWidget2 } from './UserWidget2'
import { useHeader } from './HeaderContext'
import { DividerShortFilled } from '@fluentui/react-icons'

export function Header() {
  const { title1, title2, titleUrl, rightTitle } = useHeader()

  const title = (
    <>
      <span>{title1 ?? 'Data Modelling Platform'}</span>
      {title2 && (
        <>
          <DividerShortFilled fontSize={22} />
          <span>{title2}</span>
        </>
      )}
    </>
  )

  const Icon = rightTitle?.icon

  const rTitle = rightTitle ? (
    <div className="flex items-center gap-x-1">
      {Icon && <Icon />}
      {rightTitle.text}
    </div>
  ) : null

  return (
    // Container
    <div className="flex h-[43px] items-center justify-between gap-4 border-b bg-white px-7">
      {/* Logo & Titles */}
      <div className="flex h-[22px] items-center gap-2">
        <Link to="/">
          <img
            className="h-[22px] w-[52px] translate-y-0.5"
            alt="Data Modelling Platform"
            src="/assets/logos/pwc-logo.svg"
          ></img>
        </Link>
        <div className="flex items-center text-[1.1rem] [&>a]:text-grey-darkest [&>a]:hover:text-primary">
          {titleUrl ? <Link to={titleUrl}>{title}</Link> : title}
        </div>
      </div>
      <div className="flex items-center gap-4 text-lg">
        {rTitle}
        <UserWidget2 />
      </div>
    </div>
  )
}
